var exports = {
  "Qs": "RecipientList.module__content___YTloWk",
  "Rt": "RecipientList.module__searchInput___YTloWk",
  "qc": "RecipientList.module__searchIcon___YTloWk",
  "qI": "RecipientList.module__listContainer___YTloWk",
  "XG": "RecipientList.module__scroller___YTloWk",
  "wV": "RecipientList.module__noResults___YTloWk",
  "PR": "RecipientList.module__friendList___YTloWk",
  "eH": "RecipientList.module__friendItem___YTloWk",
  "j8": "RecipientList.module__friendItemLeft___YTloWk",
  "Hb": "RecipientList.module__friendInfo___YTloWk",
  "G3": "RecipientList.module__friendName___YTloWk",
  "hw": "RecipientList.module__friendSecondary___YTloWk",
  "hP": "RecipientList.module__actionButton___YTloWk",
};

module.exports = exports;
